module.exports = __webpack_public_path__ + "media/images/flags/16/Mali-5e091d9217cb9a1f1a17cc2909ea1251.png";